var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderlineSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6923 17.3333H1.30769C0.585846 17.3333 0 17.9307 0 18.6667C0 19.4027 0.585846 20 1.30769 20H15.6923C16.4142 20 17 19.4027 17 18.6667C17 17.9307 16.4142 17.3333 15.6923 17.3333ZM8.5 16C11.745 16 14.3846 13.308 14.3846 10V1.33333C14.3846 0.597333 13.7988 0 13.0769 0C12.3551 0 11.7692 0.597333 11.7692 1.33333V10C11.7692 11.838 10.3027 13.3333 8.5 13.3333C6.69735 13.3333 5.23077 11.838 5.23077 10V1.33333C5.23077 0.597333 4.64492 0 3.92308 0C3.20123 0 2.61538 0.597333 2.61538 1.33333V10C2.61538 13.308 5.25496 16 8.5 16Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineSign);
export default __webpack_public_path__ + "static/media/underline_sign.3d0c72b9b58abb6e23f555b9e1632b81.svg";
export { ForwardRef as ReactComponent };